import React from 'react';
import { FaInstagram, FaTiktok, FaFacebookF } from 'react-icons/fa';
import './Navbar.css'; // Optional if you want to style the navbar
import logo from '../assets/phplogo.png';

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <img src={logo} alt="logo" className='navbar-logo'/>
        Purple Hippo Printing
        </div>
      <div className="navbar-socials">
        <a href="https://www.instagram.com/purplehippoprinting/" target="_blank" rel="noopener noreferrer">
          <FaInstagram />
        </a>
        <a href="https://www.tiktok.com/@purplehippoprinting" target="_blank" rel="noopener noreferrer">
          <FaTiktok />
        </a>
        <a href="https://www.facebook.com/PurpleHippoPrinting" target="_blank" rel="noopener noreferrer">
          <FaFacebookF />
        </a>
      </div>
    </nav>
  );
};

export default Navbar;
